/**
 * @generated SignedSource<<a8dcfa2358504255dd74d15d327904e7>>
 * @relayHash 57c088334e1a4823c06bc52e6a0daeff
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57c088334e1a4823c06bc52e6a0daeff

import { ConcreteRequest } from 'relay-runtime';
export type useDePointOfCareSpecialtyQuery$variables = {
  searchText: string;
};
export type useDePointOfCareSpecialtyQuery$data = {
  readonly dePointOfCareSpecialties: {
    readonly nodes: ReadonlyArray<{
      readonly betterDocKey: string | null;
      readonly id: string;
      readonly specialtyTranslations: ReadonlyArray<{
        readonly language: string;
        readonly name: string;
      }>;
      readonly synonym: string | null;
      readonly word: string;
    }> | null;
  } | null;
};
export type useDePointOfCareSpecialtyQuery = {
  response: useDePointOfCareSpecialtyQuery$data;
  variables: useDePointOfCareSpecialtyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchText"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contains",
    "variableName": "searchText"
  }
],
v2 = [
  {
    "alias": "dePointOfCareSpecialties",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 50
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": [
          {
            "word": "ASC"
          }
        ]
      },
      {
        "fields": [
          {
            "items": [
              {
                "fields": [
                  {
                    "fields": (v1/*:: as any*/),
                    "kind": "ObjectValue",
                    "name": "word"
                  }
                ],
                "kind": "ObjectValue",
                "name": "or.0"
              },
              {
                "fields": [
                  {
                    "fields": (v1/*:: as any*/),
                    "kind": "ObjectValue",
                    "name": "synonym"
                  }
                ],
                "kind": "ObjectValue",
                "name": "or.1"
              },
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "fields": (v1/*:: as any*/),
                            "kind": "ObjectValue",
                            "name": "name"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "some"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "specialtyTranslations"
                  }
                ],
                "kind": "ObjectValue",
                "name": "or.2"
              }
            ],
            "kind": "ListValue",
            "name": "or"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "PointOfCareSpecialtyConnection",
    "kind": "LinkedField",
    "name": "de_pointOfCareSpecialties",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PointOfCareSpecialty",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "word",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "synonym",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PointOfCareSpecialtyTranslation",
            "kind": "LinkedField",
            "name": "specialtyTranslations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betterDocKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDePointOfCareSpecialtyQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDePointOfCareSpecialtyQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "57c088334e1a4823c06bc52e6a0daeff",
    "metadata": {},
    "name": "useDePointOfCareSpecialtyQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f21f7497442497febe9aaa7a1415ec06";

export default node;
